import React from "react";
import image from'./Gemma.png';
import image2 from'./Gemma2.png';
import { Player } from 'video-react';
import "../../../node_modules/video-react/dist/video-react.css";

class Installation extends React.Component {
  state = {};
  render() {
    return(   <React.Fragment>
         <h3>Installation instructions </h3>
         <Player
             playsInline
             poster={image2}
             src="https://static.gemma.com.eg/videos/6-GEMMA%20Installation%20instructions.mp4"
             />
             <br />
             <h3>Installing large format tiles </h3>
             <Player
               playsInline
               poster={image}
               src="https://static.gemma.com.eg/videos/5-GEMMA%20-%20Installing%20Large%20Format%20Tiles%20(50x150cm).mp4"
               /> 
               <br />
    </React.Fragment>
            
   )
  }
}

export default Installation;
